export type LbCmd =
  | "start"
  | "pause"
  | "reset"
  | "takeover"
  | "send_mode"
  | "scope"
  | "log_sends"
  | "send_now"
  | "reload_allow";

export type LbTakeover = "off" | "dry" | "on" | "first50" | "first500";
export type LbSendMode = "cmd_wait" | "cmd_nowait" | "raw";
export type LbScope = "infcr_smart" | "infcr";
export type LbSetpointStatus = {
  takeover?: LbTakeover;
  sendMode?: LbSendMode;
  logSends?: boolean;
  scope?: LbScope;
  sendRate?: number;
  needRate?: number;
  boot?: { active?: boolean; cDone?: number; cTotal?: number; nDone?: number; nTotal?: number };
  allowList?: number | null;
  rawAvailable?: boolean;
  cmdClient?: boolean;
  stateClient?: boolean;
  inScope?: number;
  stateKnown?: number;
  stateC?: number;
  queued?: number;
  inflight?: number;
  sends1m?: number;
  resp1m?: { accepted?: number; rejected?: number; error?: number; timeout?: number };
  bad1m?: { kind: string; status: string; cps: string[] }[];
  staleGuard?: "ok" | "stale";
  skippedNull?: number;
};

export type LbStatus = {
  ts?: string;
  host?: string;
  role?: string;
  catalogVersion?: number | null;
  cps?: number;
  grids?: number;
  setpointChanges?: number;
  sc_updates?: number;
  errors?: number;
  lastError?: string | null;
  cpStatus?: number;
  gridStatus?: number;
  cpMs?: number | null;
  gridMs?: number | null;
  setpoint?: LbSetpointStatus;
};

export type LbCmdOptions = { mode?: string; on?: boolean };

export async function postLbCmd(cmd: LbCmd, opts: LbCmdOptions = {}): Promise<void> {
  const res = await fetch("/api/lb/cmd", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ cmd, ...opts }),
  });
  const data = (await res.json().catch(() => ({}))) as { error?: string };
  if (!res.ok) throw new Error(data.error || `lb cmd ${res.status}`);
}
